<template>
  <div class="h3-title-view">
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
  name: "H3TitleView",
})
</script>

<!-- Style -->
<style lang="scss" scoped>
@import "@/styles/variables";

.h3-title-view {
  color: $title-default-color;
  text-align: left;
  font-weight: normal;
  font-size: 20px;
  line-height: 28px;
}
</style>
